export const vaRules = {
	realname: [
		{
			required: true,
			message: '请输入真实姓名',
			trigger: 'change'
		}
	],
	number_in_class: [
		{
			required: true,
			message: '请输入班内序号',
			trigger: 'change'
		}
	],
	serial: [
		{
			required: true,
			message: '请输入学籍号',
			trigger: 'change'
		},
		// { required: true, min: 5, max: 25, message: '至少5位字符，且不能超过25个字符', trigger: ['blur', 'change'] },
		{ required: true, pattern: '^[^\u4e00-\u9fa5]{5,25}$', message: '请输入5-25位数字或大小写字母', trigger: 'change' }
	],
	sex: [
		{
			required: true,
			message: '请选择学生性别',
			trigger: 'change'
		}
	]
}
